import React, { useState } from 'react'
import '../styles/basicLayout.css'
import back from "../assets/back.png";
import Clock from "../assets/clock-icon.png";
import chiken from "../assets/chiken.png";
import pork from "../assets/pork.png";
import fish from "../assets/fish.png";
import turkey from "../assets/turkey.png";
import burguer from "../assets/burguer.png";
import steak from "../assets/steak.png";
import next from "../assets/next.png";
import { MIN_GRILL_TEMP_F, MIN_PROD_TEMP_F, MIN_TIME_S } from "../utils/constants";
import CategorySelector from "../components/CategorySelector";
import {
  useHistory,
} from "react-router-dom";
import { CATEGORIES } from "../utils/constants";
import Setter from '../components/Setter'

export const settings = {
  PRODUCT_TEMP: "PRODUCT_TEMP",
  GRILL_TEMP: "GRILL_TEMP",
  TIME: "TIME"
}

export default function SelectProgram() {
  const history = useHistory();
  const [setting, setSetting] = useState(settings.PRODUCT_TEMP)
  const [recipe, setRecipe] = useState({
    name: 'New recipe',
    stages: [
      {
        id: 0,
        product_temperature_f: MIN_PROD_TEMP_F,
        grill_temperature_f: MIN_GRILL_TEMP_F,
        time_s: MIN_TIME_S,
      }
    ],
    category: null,
    activeStage: 0,
  })
  return (
    <>
      <header>
        <div className="left">
          <img className="btn" width="80px" src={back} alt="" onClick={()=>history.goBack()} />
          <h3 style={{ marginLeft: 10 }}>Click Dial</h3>
        </div>
        <div className="center">
          <h2>Select Program</h2>
        </div>
        <div className="right">
        </div>
      </header>
      <article>
        <div className="left"></div>
        <div className="center" >
          
          <CategorySelector handleSetCategory={ category => history.push(`/recipes/category/${category}`)} category={recipe.category} />
          {/* <div classname="option" onclick={()=>history.push(`/recipes/category/${categories.steak}`)}>
            <img
              width={150}
              style={{ marginbottom: 10 }}
              src={steak}
              alt=""
            />
            <p>{categories.steak}</p>
          </div>

          <div classname="option" onclick={()=>history.push(`/recipes/category/${categories.chicken}`)}>
            <img
              width={150}
              style={{ marginbottom: 10 }}
              src={chiken}
              alt=""
            />
            <p>{categories.chicken}</p>
          </div>

          <div classname="option" onclick={()=>history.push(`/recipes/category/${categories.fish}`)}>
            <img
              width={150}
              style={{ marginbottom: 10 }}
              src={fish}
              alt=""
            />
            <p>{categories.fish}</p>
          </div>

          <div classname="option" onclick={()=>history.push(`/recipes/category/${categories.burguer}`)}>
            <img
              width={150}
              style={{ marginbottom: 10 }}
              src={burguer}
              alt=""
            />
            <p>{categories.burguer}</p>
          </div>

          <div classname="option" onclick={()=>history.push(`/recipes/category/${categories.turkey}`)}>
            <img
              width={150}
              style={{ marginbottom: 10 }}
              src={turkey}
              alt=""
            />
            <p>{categories.turkey}</p>
          </div>

          <div classname="option" onclick={()=>history.push(`/recipes/category/${categories.pork}`)}>
            <img
              width={150}
              style={{ marginbottom: 10 }}
              src={pork}
              alt=""
            />
            <p>{categories.pork}</p>
          </div> */}
        </div>
        <div className="right">
        </div>
      </article>
    </>
  )
}